import { render, staticRenderFns } from "./video_answer.vue?vue&type=template&id=0f6f3725&scoped=true&"
import script from "./video_answer.vue?vue&type=script&lang=js&"
export * from "./video_answer.vue?vue&type=script&lang=js&"
import style0 from "./video_answer.vue?vue&type=style&index=0&id=0f6f3725&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f3725",
  null
  
)

export default component.exports